import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { countryApi as API } from '../Apis';

import { CountriesTypes } from '../Types';

export const CountriesDocs: IDocs = {
  title: 'Countries',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.getListCountry',
};

const formatListCountries = (
  brFirst = false,
  ddiOrder = false,
  data: CountriesTypes.CountryData[],
) => {
  const listCountries = data;

  if (ddiOrder) {
    // ordenação por DDI
    listCountries.sort(
      (a: CountriesTypes.CountryData, b: CountriesTypes.CountryData) => {
        const aDDI = Number(a.ddi);
        const bDDI = Number(b.ddi);
        return aDDI > bDDI
          ? 1
          : aDDI < bDDI
          ? -1
          : a.country.localeCompare(b.country);
      },
    );
  } else {
    // ordenação pelo nome do país
    listCountries.sort(
      (a: CountriesTypes.CountryData, b: CountriesTypes.CountryData) => {
        return a.country.localeCompare(b.country);
      },
    );
  }

  if (brFirst) {
    const brPosition = listCountries
      .map((c: CountriesTypes.CountryData) => c.iso2)
      .indexOf('BR');
    if (brPosition >= 0) {
      listCountries.unshift(listCountries[brPosition]);
      listCountries.splice(brPosition + 1, 1);
    }
  }

  return listCountries;
};

const handleSucessFinalResponseFunction = (data: any, inputParameters: any) => {
  if (data?.constructor === Array)
    data = formatListCountries(
      inputParameters?.brFirst,
      inputParameters?.ddiOrder,
      data,
    );

  return data;
};

const prepareCall = (stateRequestParameters: any) => {
  return API.call.get({
    ...stateRequestParameters?.filter,
  });
};

export const CountriesMachine = GenericMachine(
  prepareCall,
  {
    docs: CountriesDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
  },
);
